/* eslint-disable */
export default {
  _Background: 'Background',
  _Hill: 'Hill',
  _Title: 'Title',
  _lgSnowball: 'lgSnowball',
  _Hand_Pointer: 'Hand_Pointer',
  _BtnGo: 'BtnGo',
  _SnowChunk3: 'SnowChunk3',
  _SnowChunk1: 'SnowChunk1',
  _SnowChunk4: 'SnowChunk4',
  _SnowFlake3: 'SnowFlake3',
  _SnowChunk2: 'SnowChunk2',
  _SnowFlake2: 'SnowFlake2',
  _SnowFlake1: 'SnowFlake1',
  _BtnStop: 'BtnStop',
  _BtnStack: 'BtnStack',
  _smSnowball: 'smSnowball',
}